var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 36,
    height: 36,
    rx: 8.1183,
    fill: "#00389C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.9072 10.0894H19.5323L23.6105 14.1676L18.3944 19.3837L13.8444 14.8338L3.70459 24.9736L6.9219 28.1909L13.8444 21.2684L18.3944 25.8183L26.8278 17.3849L30.9072 21.4643V10.0894Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSale);
export default __webpack_public_path__ + "static/media/sale.a034f05e152c95bb40e74ffe07b20e45.svg";
export { ForwardRef as ReactComponent };